var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00271 0.000329365C2.24062 0.000236721 0.00152063 2.23622 0.00192805 4.99831C0.00254142 9.1566 0.00306323 15.1564 0.0020333 19.9968C0.00144543 22.7596 2.23737 25.0002 5.00018 25.0002C9.15968 25.0002 15.1609 25.0002 20.0014 25.0002C22.7628 25.0002 25.001 22.765 25.001 20.0037C25.001 15.8443 25.001 9.84153 25.001 4.99983C25.001 2.23845 22.7625 0.000144643 20.0011 0.000181137C15.0017 0.000247209 10.0022 0.000497053 5.00271 0.000329365Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0947 12.5H17.1885V9.375C17.1885 8.5125 17.8885 8.59375 18.751 8.59375H20.3135V4.6875H17.1885C14.5994 4.6875 12.501 6.78594 12.501 9.375V12.5H9.37598V16.4062H12.501V25H17.1885V16.4062H19.5322L21.0947 12.5Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.3706d4812e946012b27ffe57bb48a8b5.svg";
export { ForwardRef as ReactComponent };